<template>
    <div class="contest-card px-2 mt-5">
        <v-row dense>
            <v-col md="6" sm="6" lg="4" v-for="(contest, index) in allfinishedcontests" :key="contest.id">
                <v-card class="elevation-0 pa-0 rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-img height="172px" src="@/assets/contest-card.png">
                        <div class="text-right pt-2 pr-2">
                            <v-menu rounded="0" transition="slide-x-transition" bottom left>
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account"
                                        v-bind="attrs" v-on="on" icon>
                                        <v-icon color="#fff">mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-card class="dropdown-menu-card" tile flat>
                                    <v-list flat outlined :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'">
                                        <v-list-item-group>
                                            <v-list-item :ripple="false" link>
                                                <v-list-item-content>
                                                    <router-link class="text-decoration-none" router
                                                        :to="`/finished-contest?id=${contest.id}`">See
                                                        Details</router-link>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-menu>
                        </div>
                        <div class="contest-details-wrapper">
                            <div class="content">
                                <div class="title mb-3">
                                    <h3>Contest {{ index + 1 }}</h3>
                                    <p>{{ contest.contest_name }}</p>
                                </div>
                                <div class="price">
                                    <h3>Total Price Worth</h3>
                                    <h4>$<span>{{ contest.total_prize_worth }}</span></h4>
                                </div>
                            </div>
                            <div class="prize-wrapper">
                                <div v-for="(prize, idx) in contest.prizes.slice(0, 3)" :key="idx" class="prize">
                                    <div class="prize-label">
                                        <v-img height="16px" width="23px" src="@/assets/cup.png"></v-img>
                                        <span class="number">{{ idx + 1 }}</span>
                                    </div>
                                    <div class="prize-amount">
                                        <h5>{{ prize }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-img>
                    <div class="card-content">
                        <v-card-actions>
                            <v-row align="center">
                                <v-col cols="12" sm="6">
                                    <h2 class="bg-danger">Contest Finished</h2>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <h3>Contestant : <span>{{ contest?.total_contestants || 0 }}</span></h3>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                        <v-card-actions>
                            <v-row align="center">
                                <v-col cols="12" sm="6">
                                    <div class="currency-leverage">
                                        <span>Deposit Amount</span>
                                        <span>${{ contest.contest_money }}</span>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="currency-leverage">
                                        <span>Total Prize Worth</span>
                                        <span>${{ contest.total_prize_worth }}</span>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                        <v-card-actions>
                            <v-row align="center">
                                <v-col cols="12" sm="6">
                                    <div class="currency-leverage">
                                        <span>Start Time </span>
                                        <span>{{ contest.formatted_start_date }}</span>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="currency-leverage">
                                        <span>End Time</span>
                                        <span>{{ contest.formatted_end_date }}</span>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                        <v-card-actions>
                            <v-btn :ripple="false" block tile :outlined="true" large elevation="0"
                                :to="`/finished-contest?id=${contest.id}`" class="custom-btn-outline" color="#ffffff">
                                <v-icon class="" :large="true" color="#647E98">mdi-circle-small
                                </v-icon>
                                See Details
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        allfinishedcontests: {
            type: Array,
            required: true
        },
        allacctypes: {
            type: Array,
            required: true
        },
    },
}
</script>